import React, { Component } from "react";
import { MsalContext, IMsalContext } from "@azure/msal-react";
import Logo from "../../assets/img/logo.svg";
import { ConfigApp } from "configApp";
import StoreFactory from "store/store";
import FeatureFlagProvider from "providers/featureFlagProvider";
import { Store } from "redux";
import { RootState } from "store/reducers/rootReducer";
import { ActionTypesCollection } from "store/actionTypes";
import { InteractionStatus } from "@azure/msal-browser";
import { Provider } from "react-redux";
import App from "app";
import ScrollToTop from "components/scroll/scrollToTop";

interface LogedInCheckState {
  storeReady: boolean;
}

class LoggedInCheck extends Component<{}, LogedInCheckState> {
  public static contextType: React.Context<IMsalContext> = MsalContext;
  public context!: React.ContextType<typeof MsalContext>;

  private store?: Store<RootState, ActionTypesCollection>;
  private unsubscribe?: () => void;

  private constructor(props: {}) {
    super(props);
    this.state = {
      storeReady: false,
    };
  }

  public componentDidMount(): void {
    this.checkAndRedirect();
    this.initializeStoreIfAuthenticated();
  }

  public componentDidUpdate(): void {
    this.checkAndRedirect();
    this.initializeStoreIfAuthenticated();
  }

  public componentWillUnmount(): void {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  private checkAndRedirect(): void {
    const { instance, accounts, inProgress } = this.context;
    if (inProgress === InteractionStatus.None && accounts.length === 0) {
      const all = instance.getAllAccounts();
      if (all.length === 0) {
        instance.loginRedirect({ scopes: ConfigApp.scopes.app });
      }
    }
  }

  private initializeStoreIfAuthenticated(): void {
    const { accounts, inProgress } = this.context;
    const isAuthenticated = accounts.length > 0;

    if (inProgress === InteractionStatus.None && isAuthenticated && !this.store) {
      this.store = StoreFactory.Create();
      this.unsubscribe = this.store.subscribe(() => {
        if (this.store) {
          FeatureFlagProvider.manageFlagChanges(this.store.getState().generalState.featureFlags);
        }
      });

      this.setState({ storeReady: true });
    }
  }

  private renderRedirecting(): JSX.Element {
    return (
      <div className="app">
        <header className="header">
          <div className="nav-spacing--start">
            <img src={Logo} className="logo" alt="Hi Five" />
          </div>
        </header>
        <main>
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 block-content--px block-content--py">
                  <div className="container bg-white pt-5 pb-5">
                    <div className="row justify-content-center">
                      <div className="col-md-6 text-center">Redirecting to login...</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }

  public render(): JSX.Element {
    const { accounts, inProgress } = this.context;
    const isAuthenticated = accounts.length > 0;

    if (inProgress !== InteractionStatus.None) {
      return this.renderRedirecting();
    }

    if (isAuthenticated && this.state.storeReady && this.store) {
      return (
        <Provider store={this.store}>
          <ScrollToTop>
            <App />
          </ScrollToTop>
        </Provider>
      );
    }

    return this.renderRedirecting();
  }
}

export default LoggedInCheck;
